import { useState, useRef, useEffect, useCallback } from "react";
// import { useGetTitle } from "../../../hooks/useGetTitle";
import { useParams } from "react-router-dom";
//import { toast } from "react-toastify";
//import * as message from "../../../constants/messages";

import {
  Box, Breadcrumbs, Button,
  Card, CardHeader, CardContent, Collapse,
  FormControl,
  IconButton, InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Typography, TextField, Tooltip,
  useTheme,
} from "@mui/material";

import styled from "styled-components";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RemoveIcon from "@mui/icons-material/Remove";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import Grid from "@mui/material/Grid";
//import ReactECharts from 'echarts-for-react';  // or var ReactECharts = require('echarts-for-react');
import * as echarts from "echarts"; // ECharts 3.0.2 호환

import { 
  useGetTableData, useGetTableDataInQueryString 
} from "../../../components/Table/hooks";

import { monitoringStrategyMonthlyInfoColumns } from "../../../constants/columns";
import { NewTableTemplate } from "../../../components/Table/TableTemplate";
import { ModalTemplate } from "../../../components/Table/ModalTemplate";
import { 
  BreadcrumbsTable,
  CollapsibleCardTemplate,
} from "../../../components/common/HelperFunc";
import { FONT_PROPS, COLORS } from "../../../styles/colors";

///////////////////////////////
// 스타일
///////////////////////////////

// 테이블 컨테이너 스타일
const TableContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 32px 16px 32px;
  display: flex;
  flex-direction: column;
`;

//////////////////////////////////
// 대책수립 결과 컴포넌트
//////////////////////////////////
const PARENT_TITLE = "모니터링";
const CHILD_TITLE = "개선대책 결과";
export function MonitoringStrategy() {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 데이터 조회에 필요한 평가연도를 상태로 관리합니다.
  const [searchYearStatus, setSearchYearStatus] = useState({});
  // 데이터 조회에 필요한 설비명을 상태로 관리합니다.
  //const [searchMachineStatus, setSearchMachineStatus] = useState({});
  // 데이터 조회에 필요한 쿼리스트링을 만듭니다.
  const qeuryString = { 
    params: { // 쿼리스트링 만들때 params를 사용하는게 규칙입니다.
      year: searchYearStatus.year,
      //machine_id: searchMachineStatus.machine_id,
    },
  } 

  // 개선대책수립 지표 조회 요청
  const getEstablishmentData = useGetTableDataInQueryString(
    "request",
    "/getMonitoringStrategyEstablishment",
    group_code,
    project_code,
    qeuryString,
  );

  // 개선대책 실행 지표 조회 요청
  const getExecutionData = useGetTableDataInQueryString(
    "request",
    "/getMonitoringStrategyExecution",
    group_code,
    project_code,
    qeuryString,
  );

  // 평가년도 필터링 목록 조회 요청
  const getFilterYearListData = useGetTableData(
    "request",
    "/getMonitoringStrategyFilterYearList",
    group_code,
    project_code,
  );

  // 평가연도 필터링 초기값 설정
  useEffect(() => {
    // 데이터가 로드되지 않았거나 비어 있는 경우 처리 중단
    if(!getFilterYearListData.data || getFilterYearListData.data.length === 0 ) {
      return;
    }
    
    // 최신 평가연도 데이터 가져오기
    let latestYearData = null;
    for(let i = getFilterYearListData.data.length - 1; i >= 0; i--) {
      if(getFilterYearListData.data[i].create_year) {
        latestYearData = getFilterYearListData.data[i];
        break;
      }
    }
    if(!latestYearData) {
      return; // 최신 평가연도 데이터가 없으면 처리 중단
    }

    const data = {
      year: latestYearData.create_year,
    };
    
    setSearchYearStatus(data);
  }, [getFilterYearListData.data]); 

  // 렌더 상태 관리
  // 렌더 상태값: none(기본값)
  const [renderFSM, setRenderFSM] = useState("none");
  const handleRenderChanged = (newValue) => setRenderFSM(newValue);

  // 데이터 조회 시, 데이터가 변경될 때마다 데이터를 갱신합니다.
  useEffect(() => {
    if(!getEstablishmentData.data || getEstablishmentData.data.length === 0 ) {
      return;
    }
    if(!getExecutionData.data || getExecutionData.data.length === 0) {
      return;
    }

    handleRenderChanged('render');
  },[getEstablishmentData.data, getExecutionData.data]);

  ////////////////////////
  // Helper Functions
  ////////////////////////

  // 선택한 평가연도의 개선대책수립 지표 데이터 가져오기
  const getSelectedYearEstablishmentData = (year) => {
    const data = getEstablishmentData.data.find(item => item.year === year);
    return data;
  };

  // 개선대책수립 총 건수 전년대비 계산
  const getCalculationYearOverYear = (currentYear, previousYear) => {
    const currentTotalCount = getSelectedYearEstablishmentData(currentYear)?.establishment_total_count;
    const previousTotalCount = getSelectedYearEstablishmentData(previousYear)?.establishment_total_count;

    // 전년 데이터가 없으면 0으로 처리
    // if(!previousTotalCount || previousTotalCount === 0) {
    //   return 0;
    // }

    const result = currentTotalCount - previousTotalCount;
    return result;
  };

  // 선택한 평가연도의 개선대책 실행 지표 데이터 가져오기
  const getSelectedYearExecutionData = (year) => {
    const data = getExecutionData.data.find(item => item.year === year);
    return data;
  };

  // 평가연도 목록 (중복 제거를 위한 작업)
  const yearList = Array.from(
    new Set(getFilterYearListData.data.map(item => item.create_year))
  );

  // 개선대책 수립 총 건수
  const strategyTotalCount = getSelectedYearEstablishmentData(searchYearStatus.year)?.establishment_total_count;
  // 전년 대비 (선택한 평가연도 기준, 전년 개선대책 총 건수 차이)
  const yearOverYearStrategy = getCalculationYearOverYear(searchYearStatus.year, (searchYearStatus.year - 1));

  ////////////////////////
  // 렌더링
  ////////////////////////
  function renderData() {
    return (
      <TableContainer>
        {/* 평가연도 필터 */}
        <FormControl size="small">
          <Box sx={{ display: "flex", alignItems: "center", gap: '16px', marginBottom: '16px'}}>
            <Typography sx={{ fontWeight: FONT_PROPS.SEMIBOLD, fontSize: 16, color: theme.text, }}>
              평가연도
            </Typography>
            <Select
              value={searchYearStatus.year || ""}
              displayEmpty
              onChange={(e) => {
                setSearchYearStatus({
                  ...searchYearStatus,
                  year: e.target.value
                });
              }}
              sx={{width: "100px",fontWeight: FONT_PROPS.SEMIBOLD,color: theme.text,fontSize: 15,}}
            >
              {yearList.reverse().map((year, index) => (
                <MenuItem
                  key={index}
                  value={year}
                  sx={{fontWeight: FONT_PROPS.SEMIBOLD,color: theme.text,fontSize: 15,}}
                >
                  {year}년
                </MenuItem>
              ))}
            </Select>
          </Box>
        </FormControl>

        <CollapsibleCardTemplate title="개선대책 수립 지표" isInitialOpen={true}>
          {/* 개선대책수립 총 건수 */}
          <Card sx={{ width: '350px',height: 'auto',boxShadow: '0px 1px 4px rgba(0,0,0,0.07)',border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", bgcolor: 'var(--mui-palette-background-paper)',mb: 4,}}>
            <CardHeader sx={{ padding: '20px 30px' }}
              title={
                <Typography sx={{ fontWeight: FONT_PROPS.SEMIBOLD, fontSize: 16, }}>
                  개선대책 수립 총 건수
                </Typography>
              }
            />
            <CardContent sx ={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 30px 20px 30px !important' }}>
              <Typography sx={{ fontWeight: FONT_PROPS.MEDIUM, fontSize: 36, }}>
                {strategyTotalCount}
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {/* 화살표 방향, 상향(45도), 하향(225도), 상향 색상: #EB1515 , 하향 색상: #21CC40 , 유지 색상: #C8C8DA */}  
                {yearOverYearStrategy > 0 && 
                  <>
                    <ArrowUpwardIcon sx={{ transform: 'rotate(45deg)', color: '#EB1515' }} /> 
                    <Typography
                    sx={{
                      fontWeight: FONT_PROPS.MEDIUM,
                      fontSize: 16,
                      color: '#EB1515',
                    }}
                    >
                      {yearOverYearStrategy}
                    </Typography>
                  </>
                }
                {yearOverYearStrategy === 0 && 
                  <>
                    <RemoveIcon sx={{ color: '#C8C8DA'}} />
                    <Typography
                      sx={{
                        fontWeight: FONT_PROPS.MEDIUM,
                        fontSize: 16,
                        color: '#C8C8DA',
                      }}
                    >
                      {yearOverYearStrategy}
                    </Typography>
                  </>
                }
                {yearOverYearStrategy < 0 && 
                  <>
                    <ArrowUpwardIcon sx={{ transform: 'rotate(225deg)', color: '#21CC40' }} /> 
                    <Typography
                      sx={{
                        fontWeight: FONT_PROPS.MEDIUM,
                        fontSize: 16,
                        color: '#21CC40',
                      }}
                    >
                      {Math.abs(yearOverYearStrategy)}
                    </Typography>
                  </>
                }
                <Typography
                  sx={{
                    fontWeight: FONT_PROPS.MEDIUM,
                    fontSize: 16,
                    marginLeft: '8px',
                  }}
                >
                  전년 대비
                </Typography>
              </Box>
            </CardContent>
          </Card>
          {/* 차트 */}
          <Box sx={{ display: 'flex', gap: 4 }}>
            {/* 개선대책 수립 건수 추이 차트 */}
            <MonthlyTrendStrategyChart chartData={getSelectedYearEstablishmentData(searchYearStatus.year)} />
            {/* 개선대책 수립 건수 3년 추이 */}
            <Card sx={{ width: '100%',height: 'auto',boxShadow: '0px 1px 4px rgba(0,0,0,0.07)',border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", bgcolor: 'var(--mui-palette-background-paper)',}}>
              <Typography sx={{ fontWeight: FONT_PROPS.SEMIBOLD,fontSize: 16,padding: '24px 24px',}}>
                개선대책 수립 건수 3년 추이
              </Typography>
              <Grid container spacing={2} justifyContent="center" sx={{ marginTop: '40px' }}>
                <Grid item>
                  <ThreeYearTrendStrategyChart chartData={getSelectedYearEstablishmentData(searchYearStatus.year - 2)} />
                </Grid>
                <Grid item>
                  <ThreeYearTrendStrategyChart chartData={getSelectedYearEstablishmentData(searchYearStatus.year - 1)} />
                </Grid>
                <Grid item>
                  <ThreeYearTrendStrategyChart chartData={getSelectedYearEstablishmentData(searchYearStatus.year)} />
                </Grid>
              </Grid>
              {/* 범례 */}
              <Box display="flex" alignItems="center" justifyContent="center" >
                <Box sx={{ width: 10, height: 10, bgcolor: '#b9e4c9', borderRadius: '50%', mr: 1.5 }} />
                <Typography variant="caption" fontWeight={FONT_PROPS.SEMIBOLD} fontSize={12} >
                  개선대책 수립 총 건수
                </Typography>
              </Box>
            </Card>
          </Box>
        </CollapsibleCardTemplate>

        <CollapsibleCardTemplate title="개선대책 실행 지표" isInitialOpen={true}>
          <Box sx = {{display: 'flex', gap: 4 }}>
            {/* 1 ~ 12월 개선대책 실행완료 지표*/}
            <MonthlyStrategyExecutionGrid cardData={getSelectedYearExecutionData(searchYearStatus.year)} />
            {/* 실행율 3년 추이 차트 */}
            <Card sx={{ width: '100%',height: 'auto',boxShadow: '0px 1px 4px rgba(0,0,0,0.07)',border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", bgcolor: 'var(--mui-palette-background-paper)',}}>
              <Box>
                <Typography sx={{ fontWeight: FONT_PROPS.SEMIBOLD, fontSize: 16, padding: '24px' }}>실행율 3년 추이</Typography>
                <Grid container spacing={3} justifyContent="center" sx={{ marginTop: '40px'}}>
                  <Grid item><StrategyExecutionRateDonut chartData={getSelectedYearExecutionData(searchYearStatus.year - 2)} /></Grid>
                  <Grid item><StrategyExecutionRateDonut chartData={getSelectedYearExecutionData(searchYearStatus.year - 1)} /></Grid>
                  <Grid item><StrategyExecutionRateDonut chartData={getSelectedYearExecutionData(searchYearStatus.year)} /></Grid>
                </Grid>
                <Box mt={2} display="flex" justifyContent="center" alignItems="center" gap={2} sx={{ padding: '40px 20px' }}>
                  <Box width={10} height={10} borderRadius="50%" bgcolor="#6287DB" />
                  <Typography sx={{ fontWeight: FONT_PROPS.MEDIUM, fontSize: 14 }}>실행율</Typography>
                </Box>
              </Box>
            </Card>
          </Box>
        </CollapsibleCardTemplate>
      </TableContainer>
    );
  }

  // MonitoringStrategy 렌더링
  return (
    <Box sx={{ bgcolor: "var(--mui-palette-background-paper)", height: "100%", overflowY: 'auto',display: "flex",flexDirection: "column",}}>
      {/* 브레드크럼 + 타이틀 */}
      <BreadcrumbsTable parentTitle={PARENT_TITLE} childTitle={CHILD_TITLE} />
      {/* 테이블 표시 */}
      {renderData()}
    </Box>
  );
}

// 월별 개선대책 수립 총 건수 추이 차트
const MonthlyTrendStrategyChart = ({ chartData }) => {
  const theme = useTheme();
  const chartRef = useRef(null);

  useEffect(() => {
    if(!chartData || chartData.length === 0) {
      return;
    }

    const myChart = echarts.init(chartRef.current);

    const option = {
      title: { // 타이틀 설정
        text: '월별 개선대책 수립 건수 추이',
        left: 'left', // 왼쪽 정렬
        //top: 'top',   // 필요시 위치 조정 가능
        textStyle: {
          fontFamily: FONT_PROPS.PRIMARY,
          fontWeight: FONT_PROPS.SEMIBOLD,
          fontSize: 16,
          //textAlign: 'left' // 필요하면 추가
        }
      },
      tooltip: { // 툴팁 설정
        trigger: 'axis',
      },
      legend: { // 범례 설정
        data: ['개선대책 수립 총 건수'],
        //data: ['유해위험요인 건수', '고위험 건수'],
        bottom: 0,
        textStyle: {
          fontFamily: FONT_PROPS.PRIMARY,
          fontWeight: FONT_PROPS.MEDIUM,
          fontSize: 12,
        },
      },
      grid: { // 그리드 설정
        left: '2%',
        right: '2%',
        bottom: '10%',
        containLabel: true,
      },
      xAxis: { // x축 설정
        type: 'category',
        boundaryGap: false,
        data: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        axisLabel: { // x축 레이블 설정
          fontFamily: FONT_PROPS.PRIMARY, // x축 폰트 패밀리
          fontWeight: FONT_PROPS.MEDIUM, // x축 폰트 굵기
          fontSize: 14,
        },
      },
      yAxis: { // y축 설정
        type: 'value',
        axisLabel: {
          fontFamily: FONT_PROPS.PRIMARY, // x축 폰트 패밀리
          fontWeight: FONT_PROPS.MEDIUM, // x축 폰트 굵기
          fontSize: 14,
        },
      },
      series: [ // 그래프 설정
        {
          name: '개선대책 수립 총 건수',
          //name: '유해위험요인 건수',
          type: 'line',
          //stack: 'Total', // 그래프 스택으로 쌓을 지 여부
          symbol: 'none', // 포인트 제거
          areaStyle: {
            opacity: 0.2, // 연한 영역 색
          },
          itemStyle: {
            color: '#B3CDE3',
          },
          data: chartData.monthly_establishment_count,
          //data: [50, 120, 150, 160, 180, 220, 280, 310, 320, 330, 340, 360],
        },
        // {
        //   name: '고위험 건수',
        //   type: 'line',
        //   //stack: 'Total', // 그래프 스택으로 쌓을 지 여부
        //   symbol: 'none', // 포인트 제거
        //   areaStyle: {
        //     opacity: 0.2, // 연한 영역 색
        //   },
        //   itemStyle: {
        //     color: '#FBB4AE',
        //   },
        //   data: chartData.monthly_high_risk_count,
        //   //data: [10, 40, 80, 100, 120, 150, 160, 170, 180, 185, 190, 200],
        // },
      ],
    };

    myChart.setOption(option);

    // resize 대응
    window.addEventListener('resize', () => myChart.resize());

    return () => {
      myChart.dispose();
    };
  }, [chartData]);

  return (
    <Card
      sx={{ 
        width: '100%',
        height: 'auto',
        //mx: 'auto',
        boxShadow: '0px 1px 4px rgba(0,0,0,0.07)',
        border: `1px solid ${theme.palette.divider}`, 
        borderRadius: "0.375rem", 
        bgcolor: 'var(--mui-palette-background-paper)',
        //overflow: 'hidden'
      }}
    >
      <CardContent>
        <div ref={chartRef} style={{ height: '400px', width: '100%' }} />
      </CardContent>
    </Card>
  );
};

// 개선대책 수립 건수 3년 추이 차트 (부분 도넛 차트)
const ThreeYearTrendStrategyChart = ({ chartData }) => {
  //const theme = useTheme();
  const chartRef = useRef(null);

  useEffect(() => {
    if(!chartData || chartData.length === 0) {
      return;
    }

    const chart = echarts.init(chartRef.current);

    const dummyValue = chartData.establishment_total_count * 0.25; // 빈공간을 위한 더미 값

    // 고위험 건수와 위험 건수를 각각의 데이터로 설정
    const realData = [
      { 
        value: chartData.establishment_total_count,
        name: '개선대책 수립 총 건수',
        itemStyle:
        { 
          color: '#B3E2CD',
          borderWidth: 2,
          borderColor: '#fff',
          borderRadius: 4,
        } 
      },
    ];
    // 빈공간을 위한 더미 데이터
    const dummyData = {
      value: dummyValue,
      name: '빈공간',
      itemStyle: 
      { 
        color: 'transparent'
      }, 
      tooltip: { show: false }, label: { show: false } 
    };
  
    // 총 건수 계산
    const total = realData.reduce((sum, d) => sum + d.value, 0);

    // 차트 옵션 설정
    const option = {
      title: {
        text: total,
        left: 'center',
        top: '45%',
        textStyle: {
          fontSize: 36,
          fontWeight: FONT_PROPS.SEMIBOLD,
          align: 'center'
        }
      },
      // tooltip: {
      //   trigger: 'item',
      //   //formatter: '{b}: {c}건 ({d}%)'
      //   formatter: function (params) {
      //     // 빈공간 제외
      //     const found = realData.find(d => d.name === params.name);
      //     if (!found) return ''; // 빈공간이면 표시 안함

      //     const percent = ((params.value / total) * 100).toFixed(1);

      //     return `
      //       <div>
      //         <strong>${params.name}</strong>
      //         <br/>건수: ${params.value}<br/>
      //         비율: ${percent}%
      //       </div>`;
      //   },
      //   // 툴팁 스타일
      //   // extraCssText: `
      //   //   padding:10px;
      //   //   background:#fff;
      //   //   border:1px solid ${theme.palette.divider};
      //   //   color:${theme.palette.text.primary};
      //   //   font-family:${FONT_PROPS.PRIMARY};
      //   //   border-radius:8px;
      //   //   `,
      // },
      series: [
        {
          name: '건수',
          type: 'pie',
          radius: ['60%', '85%'], // 도넛 크기 (안쪽, 바깥쪽)
          center: ['50%', '50%'], // 차트 중앙
          startAngle: 235, // 어디부터 시작할지 조절
          label: { show: false },
          // label: {
          //   show: true,
          //   position: 'inner', // 또는 'center', 'inner', 'outside'
          //   formatter: function (params) {
          //     return params.value === 0 ? '' : params.value;
          //   },
          //   //formatter: '{c}',   // '{c}' = value, '{b}' = name, '{d}%' = percent
          //   fontSize: 12,
          //   fontWeight: FONT_PROPS.MEDIUM,
          //   fontFamily: FONT_PROPS.PRIMARY,
          //   //color: '#333'
          // },
          labelLine: { show: false },
          // data: [
          //   { 
          //     value: highRisk,
          //     name: '고위험 건수',
          //     itemStyle: 
          //     { 
          //       color: '#FDCDAC',
          //       borderWidth: 2,
          //       borderColor: '#fff',
          //       borderRadius: 4,
          //     }
          //   },
          //   { 
          //     value: normalRisk,
          //     name: '위험 건수',
          //     itemStyle:
          //     { 
          //       color: '#B3E2CD',
          //       borderWidth: 2,
          //       borderColor: '#fff',
          //       borderRadius: 4,
          //     } 
          //   },
          //   { 
          //     value: dummyValue,
          //     name: '빈공간',
          //     itemStyle: 
          //     { 
          //       color: 'transparent'
          //     }, 
          //     tooltip: { show: false }, label: { show: false } 
          //   }
          // ]
          data: [ ...realData, dummyData ],
        }
      ]
    };

    chart.setOption(option);
    return () => chart.dispose();
  }, [chartData]);

  return(
    <Box sx={{ textAlign: 'center' }}>
      {/* 도넛차트 */}
      <div ref={chartRef} style={{ width: 200, height: 200 }} />
      <Box sx={{ transform: 'translateY(-50px)'}}>
        {/* 연도 */}
        <Typography variant="subtitle1" sx={{ fontWeight: FONT_PROPS.SEMIBOLD, fontSize: 18, marginBottom: 6 }}>
            {chartData?.year}년
        </Typography>

      </Box>
      {/* 총 건수 */}
      <Typography 
        sx={{
          display: 'inline-block',     // ✅ 줄에 맞춰 크기 조절
          width: 'fit-content',        // ✅ 글자 너비만큼 자동 조절
          height: 'fit-content',       // ✅ 높이도 텍스트에 맞게
          transform: 'translateY(-195px)',
          fontFamily: FONT_PROPS.PRIMARY,
          fontWeight: FONT_PROPS.SEMIBOLD,
          fontSize: 16,
        }}>
        총 건수
      </Typography>
    </Box>
  ); 
};

// 월별 개선대책 실행 지표
const MonthlyStrategyExecutionGrid = ({ cardData }) => {

  const monthData = [];
  for(let i = 0; i < 12; ++i) {
    monthData.push({ 
      month: i + 1, 
      count: cardData?.monthly_execution_count[i],
      alert: cardData?.monthly_uncompleted_info[i].count,
      alert_info: cardData?.monthly_uncompleted_info[i]
    });
  }
  // const monthData = [
  //   { month: 1, count: 12, alert: 3 },
  //   { month: 2, count: 12, alert: 0 },
  //   { month: 3, count: 12, alert: 3 },
  //   { month: 4, count: 12, alert: 3 },
  //   { month: 5, count: 12, alert: 3 },
  //   { month: 6, count: 12, alert: 3 },
  //   { month: 7, count: 12, alert: 3 },
  //   { month: 8, count: 12, alert: 0 },
  //   { month: 9, count: 12, alert: 3 },
  //   { month: 10, count: 12, alert: 0 },
  //   { month: 11, count: 12, alert: 3 },
  //   { month: 12, count: 12, alert: 3 },
  // ];

  return (
    <Box sx={{ maxWidth: '50%', mx: 'auto' }}>
      <Grid container spacing={2} >
        {monthData.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.month}>
            <StrategyExecutionCardTemplate {...item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
// 개선대책 실행 카드
const StrategyExecutionCardTemplate = ({ month, count, alert, alert_info }) => {
  const theme = useTheme();
  const [strategyModal, setStrategyModal] = useState(false);
  const handleStrategyModal = () => setStrategyModal(!strategyModal);

  const isComplete = alert === 0;
  const isPending = alert === -1;
  const isIncomplete = !isComplete && !isPending;

  // 테이블 참조
  // const tableRef = useRef();
  // const handleSelectedReset = () => { tableRef.current?.clearSelection(); };
  // const handleGetSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

  // 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const customTableTopToolbar = (table) => {
    return(
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {/* 왼쪽 영역 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* TODO: */}
      </Box>

      {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* 검색창 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setShowSearch((prev) => !prev)}>
            <SearchIcon />
          </IconButton>
        
          <Collapse in={showSearch} orientation="horizontal">
          <TextField
            size="small"
            placeholder="검색"
            value={globalFilter}
            onChange={(e) => {
              setGlobalFilter(e.target.value);
              table.setGlobalFilter(e.target.value);
            }}
            sx={{ minWidth: 200 }}
            variant="outlined"
            slots={{
              input: OutlinedInput,
            }}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setGlobalFilter('');
                        table.setGlobalFilter('');
                        setShowSearch(false); // 닫기
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }}
          />
          </Collapse>
        </Box>
      </Box>
    </Box>
    );
  };

  return (
    <>
      <Card 
        sx={{
          width: '250px',
          height: '120px',
          boxShadow: '0px 1px 4px rgba(0,0,0,0.07)',
          border: `1px solid ${theme.palette.divider}`, 
          borderRadius: "0.375rem", 
          bgcolor: 'var(--mui-palette-background-paper)',
        }}
      >
        <CardContent sx={{ padding: '20px 30px' }}>
          {/* 매월 */}
          <Typography sx={{ fontWeight:FONT_PROPS.SEMIBOLD, fontSize: 16 }}>
            {month}월
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* 매월 개선수립 등록 수 */}
            <Typography sx={{ fontWeight:FONT_PROPS.SEMIBOLD, fontSize: 36 }}>
              {count}
            </Typography>
            {/* 개선표시 */}
            <Box mt={1} display="flex" justifyContent="center" alignItems="center" gap={1}>
              {isComplete && (
                <>
                  <CheckCircleOutlineIcon fontSize="small" sx={{ color: 'green' }} />
                  <Typography fontSize={14} sx={{ color: 'green' }}>
                    개선 완료
                  </Typography>
                </>
              )}
              {isPending && (
                <>
                  <RemoveIcon fontSize="small" sx={{ color: '#C8C8DA' }} />
                  <Typography fontSize={14} sx={{ color: '#C8C8DA' }}>
                    개선 대기
                  </Typography>
                </>
              )}
              {isIncomplete && (
                <>
                  <NotificationsActiveIcon fontSize="small" sx={{ color: 'red' }} />
                  <Typography fontSize={14} sx={{ color: 'red' }}>
                    개선 미완료
                  </Typography>
                </>
              )}
            </Box>
            {isIncomplete && (
              <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Tooltip title="상세보기" arrow placement="bottom">
                  <Typography 
                    fontSize={12} 
                    mt={0.5} 
                    sx={{ 
                      color: 'red',
                      display: 'inline-block',
                      paddingX: 1,
                      paddingY: 1,
                      borderRadius: 1,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
                      },
                    }}
                    onClick={handleStrategyModal}
                  >
                    🔔 {alert}
                  </Typography>
                </Tooltip>
              </Box>
            )}
            
            {isPending && (
              <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Typography 
                  fontSize={12} 
                  mt={0.5} 
                  sx={{ 
                    color: 'red',
                    // display: 'inline-block',
                    // paddingX: 1,
                    // paddingY: 1,
                    // borderRadius: 1,
                    // cursor: 'pointer',
                    // transition: 'all 0.2s ease',
                    // '&:hover': {
                    //   backgroundColor: theme.palette.action.hover,
                    //   boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
                    // },
                  }}
                  // onClick={handleUseModal}
                >
                  {/* 🔔 {alert} */}
                </Typography>
              </Box>
            )}
            {isComplete && (
              <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Typography 
                  fontSize={12}
                  mt={0.5}
                  sx={{
                    color: 'green',
                    // display: 'inline-block',
                    // paddingX: 1,
                    // paddingY: 1,
                    // borderRadius: 1,
                    // cursor: 'pointer',
                    // transition: 'all 0.2s ease',
                    // '&:hover': {
                    //   backgroundColor: theme.palette.action.hover,
                    //   boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
                    // },
                  }}
                  //onClick={handleUseModal}
                >
                  {/* 🔔 {alert} */}
                </Typography>
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
      {/* 개선 미완료 상세정보 모달 */}
      <ModalTemplate 
        isOpen={strategyModal}
        handleConfirm={handleStrategyModal}
        handleCancel={handleStrategyModal}
        confirmText="확인"
        enableSingleActionButton={true}
        title={`${month}월 개선대책 미완료 상세정보`}
        containerSX={{ width: 'auto', height: 'auto' }}
      >
        <NewTableTemplate 
          columns={monitoringStrategyMonthlyInfoColumns}
          data={(alert_info && alert_info.data) || []}
          topToolbarContent={customTableTopToolbar}
          enableEditing={false}
          enableCustomGlobalFilter={true}
          enabledSelectionRow={false}
          enabledSelectionAllRow={false}
          templateSX ={{
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: "0.375rem", 
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
          }}
        />
      </ModalTemplate >
    </>
  );
};

// 실행율 3년 추이 차트 (도넛 차트)
const StrategyExecutionRateDonut = ({ chartData }) => {
  const chartRef = useRef(null);
  const remaining = 100 - (chartData?.execution_percent || 0);

  useEffect(() => {
    const chart = echarts.init(chartRef.current);

    const option = {
      tooltip: { show: false },
      legend: { show: false },
      series: [
        {
          type: 'pie',
          radius: ['70%', '90%'],
          center: ['50%', '50%'],
          startAngle: 90,
          label: {
            show: true,
            position: 'center',
            formatter: `${chartData?.execution_percent || 0}%`,
            fontSize: 36,
            fontWeight: FONT_PROPS.SEMIBOLD,
            //color: '#333'
          },
          labelLine: { show: false },
          data: [
            {
              value: chartData?.execution_percent || 0,
              name: '실행율',
              itemStyle: {
                color: '#6287DB'
              }
            },
            {
              value: remaining,
              name: '나머지',
              itemStyle: {
                color: '#dee6f6'
              },
              tooltip: { show: false }
            }
          ]
        }
      ]
    };

    chart.setOption(option);
    return () => chart.dispose();
  }, [chartData]);

  return (
    <Box textAlign="center">
      <div ref={chartRef} style={{ width: 200, height: 200 }} />
      <Typography sx={{ fontWeight: FONT_PROPS.SEMIBOLD,  fontSize: 18, marginTop: '12px' }}>{chartData?.year || 0}년</Typography>
    </Box>
  );
};